import useCollection from 'core/hooks/useCollection'

const useCases = (...args) => useCollection('cases', ...args)
export default useCases
